import styles from './logo.module.scss';

const Logo = () => {
  return <div className={styles.logo} />;
};

export default Logo;
